/* import __COLOCATED_TEMPLATE__ from './multi-select-header.hbs.js'; */
import { computed } from "@ember/object";
import { reads } from "@ember/object/computed";
import { attributeBindings, classNames, tagName } from "@ember-decorators/component";
import SelectKitHeaderComponent from "select-kit/components/select-kit/select-kit-header";
const MultiSelectHeader = dt7948.c(class MultiSelectHeader extends SelectKitHeaderComponent {
  static {
    dt7948.g(this.prototype, "caretUpIcon", [reads("selectKit.options.caretUpIcon")]);
  }
  #caretUpIcon = (dt7948.i(this, "caretUpIcon"), void 0);
  static {
    dt7948.g(this.prototype, "caretDownIcon", [reads("selectKit.options.caretDownIcon")]);
  }
  #caretDownIcon = (dt7948.i(this, "caretDownIcon"), void 0);
  static {
    dt7948.g(this.prototype, "ariaLabel", [reads("selectKit.options.headerAriaLabel")]);
  }
  #ariaLabel = (dt7948.i(this, "ariaLabel"), void 0);
  get caretIcon() {
    return this.selectKit.isExpanded ? this.caretUpIcon : this.caretDownIcon;
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [computed("selectKit.isExpanded", "caretUpIcon", "caretDownIcon")]);
  }
}, [attributeBindings("ariaLabel:aria-label"), classNames("multi-select-header"), tagName("summary")]);
export default MultiSelectHeader;